<template>
    <div>
        <aside class="left-sidebar" data-sidebarbg="skin5" v-bind:class="{ min: activarLateral }">
            <div class="scroll-sidebar" >
                <nav class="sidebar-nav">            
                    <ul id="sidebarnav">
                        <li class="sidebar-item"  v-for="(i) in menuBilling" :key="i.m_id" v-bind:class="{ 'sub': (i.type === 2)}">
                            <router-link :to="i.ruta" exact-active-class="active" class="sidebar-link waves-effect waves-dark" v-if="i.type==1">
                                <i :class="i.icon"></i>
                                <span class="hide-menu">{{ i.name }}</span>
                            </router-link>
                            <div v-else-if="i.type==2" class="sidebar-link has-arrow waves-effect waves-dark" v-on:click="activeMenuMoneyIn" v-bind:class="{ active: i.mActive }" aria-expanded="false">
                                <i :class="i.icon"></i>
                                <span class="hide-menu">{{ i.name }} </span>
                            </div>
                            <div v-else-if="i.type==3" class="sidebar-link has-arrow waves-effect waves-dark" v-on:click="activeMoneyOut" v-bind:class="{ active: i.mActive }" aria-expanded="false">
                                <i :class="i.icon"></i>
                                <span class="hide-menu">{{ i.name }} </span>
                            </div>

                            <ul aria-expanded="false" class="collapse first-level" v-bind:class="{ in: i.mActive }" >
                                <li class="sidebar-item" v-for="(item,index) in i.items" :key="index">
                                    <router-link :to="item.ruta" exact-active-class="active" class="sidebar-link">
                                        <span class="hide-menu">{{ item.name }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
                <div class="btnAsideAction" @click="ShowHiddenAside">
                    <i class="fas fa-chevron-left" v-bind:class="{ min:activarLateral }"></i>
                </div>
            </div>
        </aside>
    </div>
</template>
<script>
export default {
    name:'Aside',
    data(){
    return {
        isMoneyIn: true,
		isMoneyOut: false,
        activarLateral: false,
        winnerWidth: window.innerWidth,
        menuBilling: {},
        indiceIn: 0,
        indiceOut: 0,
     }
    },
    created(){
        if(localStorage.getItem('isMoneyIn')==null){
            localStorage.setItem('isMoneyIn', 1);
            this.isMoneyIn = true;
        }else{ this.isMoneyIn = (localStorage.getItem('isMoneyIn') != 0) ? true : false;}
        if(localStorage.getItem('isMoneyOut') == null){
            localStorage.setItem('isMoneyOut', 0);
            this.isMoneyOut = false;
        }else{ this.isMoneyOut =(localStorage.getItem('isMoneyOut') != 0) ? true : false;}


        if(
            this.$router.currentRoute.name!='Invoices' &&
            this.$router.currentRoute.name!='Estimates' &&
            this.$router.currentRoute.name!='InvoicesRec' &&
            this.$router.currentRoute.name!='PaymentsReceived' &&
            this.$router.currentRoute.name!='Expenses' &&
            this.$router.currentRoute.name!='Employees' &&
            this.$router.currentRoute.name!='Vendors' &&
            this.$router.currentRoute.name!='Banking' &&
            localStorage.getItem('isMoneyIn') != 0  &&
            localStorage.getItem('isMoneyOut') != 0 
            ){
            this.desactivarMoneys();
        }
        this.estructuraMenu();
        this.validarMenu();
    },
    methods: {
        estructuraMenu(){
            this.menuBilling={
                1 : {
                    name : 'Dashboard Bill',
                    ruta : {name: 'Billing'},
                    icon : 'fas fa-home',
                    type : 1,
                    m_id : 0,
                },
                2 : {
                    name : 'Customer',
                    ruta : {name: 'Customer'},
                    icon : 'fas fa-user',
                    type : 1,
                    m_id : 10,
                },
                3 : {
                    name : 'Money In',
                    icon : 'fas fa-dollar-sign',
                    type : 2,
                    mActive: this.isMoneyIn ,
                    items: {
                        1: {
                            name : 'Invoices',
                            ruta : {name: 'Invoices'},
                            m_id : 1,
                        },
                        2: {
                            name : 'Estimates',
                            ruta : {name: 'Estimates'},
                            m_id : 2,
                        },
                        3: {
                            name : 'Recurring Invoices',
                            ruta : {name: 'InvoicesRec'},
                            m_id : 3,
                        },
                        4: {
                            name : 'Payments received',
                            ruta : {name: 'PaymentsReceived'},
                            m_id : 4,
                        }
                    }
                },
                4 : {
                    name : 'Money Out',
                    icon : 'fas fa-coins',
                    type : 3,
                    mActive: this.isMoneyOut,
                    items: {
                        1: {
                            name : 'Expenses',
                            ruta : {name: 'Expenses'},
                            m_id : 5,
                        },
                        2: {
                            name : 'Subcontractors',
                            ruta : {name: 'Employees'},
                            m_id : 6,
                        },
                        3: {
                            name : 'Vendors',
                            ruta : {name: 'Vendors'},
                            m_id : 7,
                        },
                        4: {
                            name : 'Write Check',
                            ruta : {name: 'WriteaCheck'},
                            m_id : 8,
                        },
                        5: {
                            name : 'Banking',
                            ruta : {name: 'Banking'},
                            m_id : 9,
                        },
                    }
                },
                5 : {
                    name : 'Reports',
                    ruta : {name: 'BillingReport'},
                    icon : 'fas fa-chart-line',
                    type : 1,
                    m_id : 11,
                },
                6 : {
                    name : 'Setting',
                    ruta : {name: 'Setting'},
                    icon : 'fas fa-cog',
                    type : 1,
                    m_id : 12,
                }
            };
        },
        validarMenu(){
            let menu = [];
            if(window.user_type == 0){ 
                menu = this.menuBilling; 
                this.indiceIn=3;
                this.indiceOut=4;
            }
            else
            {
                menu.push(this.menuBilling[1]);
                let privilegios = this.$store.getters.privilegiesSesion;
                let modulos = privilegios.modulos.billing;
                console.log('modulos a seleccionar =', modulos);
                for (let i in modulos) {
                    for (let m in this.menuBilling){
                        if(m == 3 || m==4)
                        {
                            //console.log('item'+m+' =', this.menuBilling[m].items)
                            let SubMoney={};
                            let subMenus = [];
                            for (let item in this.menuBilling[m].items) {  
                                //if(m==4){debugger;}
                                if(this.menuBilling[m].items[item].m_id == modulos[i] )
                                {
                                    //console.log('comparar '+this.menuBilling[m].items[item].m_id+'=='+modulos[i]);
                                    //console.log('agregando', this.menuBilling[m].items[item])
                                    subMenus.push(this.menuBilling[m].items[item]);
                                }   
                            }
                            //console.log('subMenus', subMenus)
                            //debugger;
                            if(subMenus.length > 0)
                            {
                                let group =0;
                                if(m==3){ group =this.indiceIn ;}
                                if(m==4){ group =this.indiceOut;}                                
                                if (group == 0) {
                                    SubMoney['name']= this.menuBilling[m].name;
                                    SubMoney['icon']= this.menuBilling[m].icon;
                                    SubMoney['type']= this.menuBilling[m].type;
                                    SubMoney['mActive']= this.menuBilling[m].mActive;
                                    SubMoney['items']=subMenus ;
                                    menu[m] = SubMoney;
                                    console.log('agregado'+m+' = ',menu[m])
                                    if(m==3 && this.indiceIn == 0){ this.indiceIn=m;}
                                    if(m==4 && this.indiceOut==0){ this.indiceOut=m;}
                                }
                                else{
                                    menu[group].items.push(subMenus[0]);
                                    //console.log('agregado'+group+' = ',menu[group].items)
                                }
                                subMenus = [];
                            }
                        }
                        else{
                            //console.log('comparar '+this.menuBilling[m].m_id+'=='+modulos[i]);
                            if(this.menuBilling[m].m_id == modulos[i] )
                            {
                                menu[m]=this.menuBilling[m];
                                console.log('agregado'+m+' = ',menu[m])
                            }
                        }
                    }
               }
                this.menuBilling = [];            
               for (let i in menu) {
                this.menuBilling.push(menu[i])
                   if (menu[i].type==2) {
                       this.indiceIn = this.menuBilling.length - 1;
                   }
                   if (menu[i].type==3) {
                       this.indiceOut = this.menuBilling.length - 1;
                   }
               }               
                console.log('nuevo menu =',this.menuBilling);
            }
        },
        activeMoneyOut(){
            this.isMoneyOut= !this.isMoneyOut;
            this.menuBilling[this.indiceOut].mActive=this.isMoneyOut;
            if(this.isMoneyOut){localStorage.setItem('isMoneyOut', 1);}
            else{localStorage.setItem('isMoneyOut', 0);}
            
            this.isMoneyIn= false;
            this.menuBilling[this.indiceIn].mActive=this.isMoneyIn;
            localStorage.setItem('isMoneyIn', 0);
        },
		activeMenuMoneyIn(){
            this.isMoneyIn= !this.isMoneyIn;
            this.menuBilling[this.indiceIn].mActive=this.isMoneyIn;
            if(this.isMoneyIn){localStorage.setItem('isMoneyIn', 1);}
            else{localStorage.setItem('isMoneyIn', 0);}

            this.isMoneyOut= false;
            this.menuBilling[this.indiceOut].mActive=this.isMoneyOut;
            localStorage.setItem('isMoneyOut', 0);
        },
        desactivarMoneys(){
            this.isMoneyIn= false;
            this.isMoneyOut= false;
            localStorage.setItem('isMoneyIn', 0);
            localStorage.setItem('isMoneyOut', 0);
        },
        ShowHiddenAside(){
            this.activarLateral= !this.activarLateral;
            this.$emit('activarLateral', this.activarLateral);
            this.desactivarMoneys()
        }
    },
    mounted: function(){
        if(this.winnerWidth < 1050)
        {
            this.ShowHiddenAside();
        }        
    }
	
};
</script>
<style>
.left-sidebar{position: fixed;}
.btnAsideAction {
    position: absolute;
    bottom: -18px;
    top:initial;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: #343435;
    cursor: pointer;
    padding: 10px 4px 4px 4px;
    line-height: 21px;
    text-align: center;
    color: #fff;
}
aside.left-sidebar.min {
    width: 60px;
    z-index: 100;
}   
aside.left-sidebar.min .scroll-sidebar {height: 100%;}
aside.left-sidebar.min .scroll-sidebar .btnAsideAction {    bottom: 0%;}
aside.left-sidebar.min .scroll-sidebar .btnAsideAction i:before{ content: "\f054";}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item, 
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item ul.collapse.first-level li.sidebar-item{ width: 60px; transition: all 0.5s ease-out; position: relative;}


aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover ul.collapse.first-level,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover ul.collapse.first-level.in {
    position: absolute;
    top: 0px;
    left: 40px;
    width: 170px;   
}

aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item a.sidebar-link{ }
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item a.sidebar-link span.hide-menu, 
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item div.sidebar-link span.hide-menu,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item ul.collapse.first-level,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item ul.collapse.first-level.in
{
    display:none;
}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover ul.collapse.first-level,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover ul.collapse.first-level.in,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover ul.collapse.first-level li.sidebar-item a.sidebar-link span.hide-menu
{  
    display: block; 
}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover ul.collapse.first-level li.sidebar-item a.sidebar-link{border-left: 2px solid transparent;}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover a.sidebar-link,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover div.sidebar-link.has-arrow.waves-effect.waves-dark,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover div.sidebar-link.has-arrow.waves-effect.waves-dark.active
{
    border-left: 2px solid #137eff;
    opacity: 1;
}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover div.sidebar-link,
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item:hover ul.collapse.first-level{
    background: #191919;
}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item > .has-arrow::after{
    transition: all 0.5s ease-out;
}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item > .has-arrow::after
{
    -webkit-transform: rotate(135deg) translate(0, -50%) !important;
    transform: rotate(135deg) translate(0, -50%) !important;
}

@media(max-width: 1024px){
    .sidebar-nav ul .sidebar-item .sidebar-link {
        padding: 8px 8px;
    }
}
</style>

